import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Investments from './components/Investments';
import Brokerage from './components/Brokerage';
import PropertyManagement from './components/PropertyManagement';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PreQualification from './components/PreQualification';
import { Toaster } from './components/ui/toaster';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <Investments />
    <Brokerage />
    <PropertyManagement />
    <Team />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pre-qualification" element={<PreQualification />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;